import React from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';

const BADGES = ['Multilingual Support', '100% Free', 'Quick Response'];

export default function WhatsAppBanner() {
  return (
    <section className="px-4 sm:px-6 py-8 md:py-10 bg-secondary-50 border-t border-secondary-100">
      <div className="max-w-4xl mx-auto bg-brand-purple rounded-3xl p-6 sm:p-8 md:p-12
                      flex flex-col md:flex-row items-center gap-8">
        <div className="flex-1 text-center md:text-left">
          <h2 className="font-display font-black text-2xl md:text-3xl text-white mb-2">
            Get a job instantly with just a Call or WhatsApp
          </h2>
          <p className="text-white/70 text-sm mb-6">
            Our multilingual support team is ready to help you find the right job — in your language.
          </p>
          <div className="flex flex-wrap gap-3 justify-center md:justify-start">
            {BADGES.map(b => (
              <span key={b}
                    className="px-3 py-1 rounded-full text-xs font-black uppercase tracking-wide
                               bg-white/10 text-white border border-white/20">
                {b}
              </span>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          {/* Replace 917002502224 with the real number before shipping */}
          <a href="https://wa.me/917002502224"
             className="flex items-center gap-2 px-6 py-3 rounded-xl font-black text-sm
                        bg-[#25D366] text-white hover:brightness-110 active:scale-95 transition-all">
            <FaWhatsapp className="text-lg" /> WhatsApp Us
          </a>
          <a href="tel:+917002502224" aria-label="Call JobxBharat"
             className="flex items-center gap-2 px-6 py-3 rounded-xl font-black text-sm
                        bg-white text-brand-purple hover:brightness-95 active:scale-95 transition-all">
            <FaPhone className="text-lg" /> Call Now
          </a>
        </div>
      </div>
    </section>
  );
}
